import { useMemo, useState } from "react";
import {
    setErrorAlert,
    clearAlerts,
    setListMessage
} from "./../../../config/redux/alerts/alertsActions";
import { FormikValues } from "formik";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useTranslation } from "react-i18next";
import { getBackendErrorMessage } from '../../common/utils/getBackendErrorMessage';

import {
    setRegistrationComplete,
    clearCompanyData,
} from "../../../config/redux/register/registerActions";
import {registerCompany, registerCompanyAdmin, registerPersonAdmin} from "../../../connectors/auth/connectors/index";
import { transformData } from "../actions/transformRegisterData";
import { IResetForm } from "../../common/models/resetForm.type";
import { useUserData } from "../../common/hooks/useUserData";
import { LangEnumToCountryName } from "../../common/converters/language";

export const useRegistration = () => {
    const { t } = useTranslation("admin");
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useUserData();

    const {
        data: { alreadyRegistered, requestId, name, taxNumber, companyAddress, regon, country }, success,
    } = useSelector((state: RootStateOrAny) => state.register.company);
    const dispatch = useDispatch();

    const initValues = useMemo(
        () => ({
            name: name ? name : "",
            taxNumber: taxNumber ? taxNumber : "",
            regon: regon ? regon : "",
            city: companyAddress ? companyAddress.city : "",
            street: companyAddress ? companyAddress.street : "",
            postalCode: companyAddress ? companyAddress.postalCode : '',
            email: !user ? "" : user.emails[0],
            phoneNumber: "",
            bdo: "",
            multiDepartment: false,
            accept: false,
            country: country, 
            countryText: LangEnumToCountryName(country)
        }),
        [name, success]
    );


    const register = async (values: FormikValues, { resetForm }: IResetForm) => {
        setIsLoading(true)
        try {
            dispatch(clearAlerts())
            const { user, department } = transformData(values);
            const body = {
                name: values.name,
                taxNumber: values.taxNumber,
                requestId: requestId,
                multiDepartment: values.multiDepartment,
                bdoNumber: values.bdo,
                contactPerson: user,
                regon: values.regon,
                department,
                country: values.country
            };
            const url = window.location.href.split('/');
            const route = window.location.href.split('/')[url.length - 1];
            const inactive = false;
            const res = inactive ? await registerCompany(body) : (!!body.taxNumber ? await registerCompanyAdmin(body) : await registerPersonAdmin(body));
            resetForm();
            dispatch(setRegistrationComplete());
            dispatch(setListMessage(t("auth.messages.registrationSuccess")))
        } catch (err) {
            if (err.response) {
                if (err.response.status === 401) {
                    dispatch(setErrorAlert(t("auth.errors.unauthorized")))
                } else {
                    dispatch(setErrorAlert(getBackendErrorMessage(err, t)));
                }
            } else if (err.request) {
                dispatch(setErrorAlert(t("auth.errors.noResponse")))
            } else {
                dispatch(setErrorAlert(t("auth.errors.requestSetupError")))
            }
        }
        setIsLoading(false)
    };

    const cancelForm = () => {
        dispatch(clearCompanyData());
    };

    return {
        register,
        alreadyRegistered,
        cancelForm,
        initValues,
        isLoading
    };
};